import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Info } from "lucide-react";
import { useParams } from "react-router-dom";
import { alarmConfig } from "../../config/alarmConfigRelay2";
import AlarmDetailsModal from "../../components/AlarmDetailsModal";

export default function Relay2Alarms() {
  const { t } = useTranslation();

  const { deviceId } = useParams();
  const [states, setStates] = useState({});

  const [details, setDetails] = useState(null);
  const [formData, setFormData] = useState({});

  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  // ✅ İlk yüklemede backend’den değerleri çek
  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(`${API_BASE}/measurements/alarms/relay2/?deviceId=${deviceId}`);

        if (!res.ok) throw new Error("HTTP " + res.status);
        const json = await res.json();
        // console.log("API states:", json);
        setStates(json); // description:value map
      } catch (err) {
        console.error("alarm fetch error:", err);
      }
    }
    fetchData();
  }, [API_BASE, deviceId]);

  /*
   // ✅ Modal içindeki Yaz butonu
   const handleWrite = async (fieldKey, rawValue) => {
     if (!details) return;
 
     try {
       // Field configini bul
       const field = details.fields.find((f) => f.key === fieldKey);
       if (!field) throw new Error("Field bulunamadı: " + fieldKey);
 
       let value = parseFloat(rawValue);
       let factor = field.factor || 1;
       let format = "uint16"; // default format
 
       // Eğer divideByCTR veya divideByVTR varsa önce VTR/CTR değerlerini çek
       if (field.divideByCTR || field.divideByVTR) {
         const res = await fetch(`${API_BASE}/measurements/getVTRandCTR?deviceId=${deviceId}`);
         const { VTR, CTR } = await res.json();
 
         if (field.divideByCTR && CTR) {
           value = value / CTR;
         }
         if (field.divideByVTR && VTR) {
           value = value / VTR;
         }
       }
 
       // Faktöre göre ölçekle
       value = value / factor;
 
       // Backend’e gönder
       const res = await fetch(`${API_BASE}/write/alarm2`, {
         method: "POST",
         headers: { "Content-Type": "application/json" },
         body: JSON.stringify({
           deviceId,
           register: field.address,
           format,
           factor,
           value,
         }),
       });
 
       if (!res.ok) throw new Error("HTTP " + res.status);
       const result = await res.json();
       console.log(result);
 
       // ✅ Backend’ten gelen ok/success değerlerine göre karar ver
       if (result.ok && result.success) {
         console.log("✅ Yazma başarılı:", result);
         alert("Yazma başarılı!");
       } else {
         console.error("❌ Yazma hatası:", result.error || "Bilinmeyen hata");
         alert(`Yazma başarısız: ${result.error || "Bilinmeyen hata"}`);
       }
     } catch (err) {
       console.error("❌ Yazma hatası:", err);
       alert(`Yazma hatası: ${err.message}`);
     }
   };*/





  // ✅ Form açma (modal)
  const handleOpenDetails = (alarmKey) => {
    const alarm = alarmConfig[alarmKey];
    if (!alarm) return;

    const prefill = {};
    alarm.fields.forEach((f) => {
      if (f.description && states[f.description] !== undefined) {
        prefill[f.key] = states[f.description];
      }
    });

    setDetails(alarm);
    setFormData(prefill);
  };




  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-6">{t('alarms.relay2Title')}</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {Object.entries(alarmConfig).map(([key, alarm]) => {
          const isActive = states[alarm.state.description] === 1;

          return (
            <div
              key={key}
              className="bg-white shadow rounded-lg p-4 flex items-center justify-between"
            >
              <h2 className="text-lg font-semibold">{t(alarm.title)}</h2>
              <div className="flex items-center gap-3">

                <div className="text-sm font-semibold">
                  {isActive ? (
                    <span className="text-green-600">{t('alarms.active')}</span>
                  ) : (
                    <span className="text-gray-500">{t('alarms.passive')}</span>
                  )}
                </div>


                {/* ✅ Detaylar Butonu */}
                <button
                  className={`p-2 rounded-full transition ${isActive
                    ? "hover:bg-gray-100 text-gray-500 hover:text-indigo-600"
                    : "bg-gray-200 text-gray-400 cursor-not-allowed"
                    }`}
                  onClick={() => isActive && handleOpenDetails(key)}
                  disabled={!isActive}
                >
                  <Info className="w-5 h-5" />
                </button>
              </div>
            </div>
          );
        })}

      </div>


      {/* ✅ Detay Form Modal */}
      {details && (
        <AlarmDetailsModal
          alarm={details}
          formData={formData}
          onClose={() => setDetails(null)}
        />

      )}
    </div>
  );
}
